import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from "./Components/Navbar";
import Home from "./Components/Home";
import Services from './Components/Services';
// import WhyUs from './Components/WhyUs';
import OurStory from "./Components/OurStory";
import Contact from "./Components/Contact";
import Footer from "./Components/Footer";
// import Furniture from './Components/Furniture';
import Rugs from './Components/Rugs';
import Cushions from './Components/Cushions';
// import BedBath from './Components/BedBath';
// import KitchenDining from './Components/KitchenDining';
import Towel from './Components/Towel';
import Pouf from './Components/Pouf';
import Curtain from './Components/Curtain';
// import Holiday from './Components/Holiday';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import logo from './Img/whatsapp_logo.png';
import logo from './Img/Contact Icons/whatsapp.png';
import ScrollTop from './Components/ScrollTop';
import Product from './Components/Product';

function App() {
  return (
    <div className="textured-background" style={{ fontFamily: "'Roboto Slab',Kode Mono, monospace" }}>
      <Router>
        <ScrollTop />
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/Services" element={<Services />} />
          {/* <Route path="/WhyUs" element={<WhyUs/>} /> */}
          <Route path="/About" element={<OurStory />} />
          <Route path="/Contact" element={<Contact />} />
          <Route path="/Product" element={<Product />} />
          {/* <Route path="/Furniture" element={<Furniture />} /> */}
          <Route path="/Rugs" element={<Rugs />} />
          <Route path="/Cushions" element={<Cushions />} />
          {/* <Route path="/BedBath" element={<BedBath />} /> */}
          {/* <Route path="/KitchenDining" element={<KitchenDining />} /> */}
          <Route path="/Towel" element={<Towel />} />
          <Route path="/Pouf" element={<Pouf />} />
          <Route path="/Curtain" element={<Curtain />} />
          {/* <Route path="/Holiday" element={<Holiday />} /> */}
        </Routes>
        <Footer />
      </Router>
      <div
        className="fixed-bottom p-3"
        style={{
          zIndex: 6,
          right: "20px",
          left: "auto",
        }}
      >
        <a
          href="https://wa.me/+917460012246?"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Chat with us on WhatsApp"
          style={{
            display: "inline-block",
            borderRadius: "50%",
            boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
            transition: "transform 0.2s ease-in-out",
          }}
          onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.05)")}
          onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
        >
          <img src={logo} alt="WhatsApp Logo" width={50} height={50} />
        </a>
      </div>
    </div>
  );
}
export default App;